import React, { useMemo } from 'react';
import { Button, debounce, Grid, IconButton, InputBase, makeStyles, Paper, styled } from '@material-ui/core';
import { Add, Search } from '@material-ui/icons';
import Theme from '../../ui/Theme';
import AddCategoryPopup from './AddCategoryPopup';

const CustomButton = styled(Button)({
  fontFamily: 'Lato',
  color: 'white',
  backgroundColor: Theme.palette.primary.main,
  borderRadius: '4px',
  width: '120px',
  height: '30px',
  fontSize: '11px',
  fontWeight: '500',
  lineHeight: '14.96px',
  textAlign: 'center',
  '&:hover': {
    backgroundColor: Theme.palette.primary.main,
    color: 'white',
  },
});
const useStyles = makeStyles({
  searchBox: {
    width: '320px',
    height: '32px',
    borderRadius: '4px',
  },
  searchText: {
    width: '280px',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16.8px',
    textAlign: 'left',
  },
  searchIcon: {
    padding: '4px',
  },
});
const SearchContainer = ({ tabValue, setSearchVal, setOpen, open }) => {
  const classes = useStyles();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const debouncedSetSearchVal = useMemo(() => debounce((value) => setSearchVal(value), 300), [setSearchVal]);
  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center">
      <Grid item>
        <Paper component="form" className={classes.searchBox} onSubmit={(e) => e.preventDefault()}>
          <IconButton type="button" className={classes.searchIcon} aria-label="search">
            <Search />
          </IconButton>
          <InputBase
            onChange={({ target: { value } }) => debouncedSetSearchVal(value)}
            className={classes.searchText}
            placeholder="Search Collection"
            inputProps={{ 'aria-label': 'search google maps' }}
          />
        </Paper>
      </Grid>
      <Grid item>
        <CustomButton
          variant="contained"
          startIcon={<Add style={{ fontSize: '12px', fontWeight: '500' }} />}
          onClick={handleOpen}
        >
          Add Category
        </CustomButton>
        {open && <AddCategoryPopup isEdit={false} isOpen={open} handleClose={handleClose} tabValue={tabValue} />}
      </Grid>
    </Grid>
  );
};
export default SearchContainer;
